import { apiClient } from '../utils/apiClient';

export interface Patient {
  id: string;
  name: string;
  age: number;
  location: string;
  phone?: string;
  email?: string;
  conditions: string[];
  careNeeds: string[];
  status: 'active' | 'pending' | 'completed' | 'on_hold';
  lastVisit: string;
  nextAppointment?: string;
  avatar?: string;
  notes?: string;
  emergencyContact?: {
    name: string;
    phone: string;
    relationship: string;
  };
}

export interface PatientSearchParams {
  q?: string;
  status?: string;
}

class PatientManagementService {

  async getPatients(): Promise<Patient[]> {
    return apiClient.get<Patient[]>('/patient-management/patients');
  }

  async getPatient(patientId: string): Promise<Patient> {
    return apiClient.get<Patient>(`/patient-management/patients/${patientId}`);
  }

  async searchPatients(params: PatientSearchParams): Promise<Patient[]> {
    const searchParams = new URLSearchParams();
    if (params.q) searchParams.append('q', params.q);
    if (params.status) searchParams.append('status', params.status);
    
    return apiClient.get<Patient[]>(`/patient-management/patients/search?${searchParams}`);
  }

  async updatePatientStatus(patientId: string, status: string): Promise<void> {
    await apiClient.patch(`/patient-management/patients/${patientId}/status`, { status });
  }

  async updatePatientNotes(patientId: string, notes: string): Promise<void> {
    await apiClient.patch(`/patient-management/patients/${patientId}/notes`, { notes });
  }

  async removePatient(patientId: string): Promise<void> {
    await apiClient.delete(`/patient-management/patients/${patientId}`);
  }
}

export const patientManagementService = new PatientManagementService();
